'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon$1 = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
var widths = require('../../../../enums/widths.js');
var fontIcon = require('../../icon/font-icon/font-icon.js');
var baseTooltip = require('../base-tooltip/base-tooltip.js');
var moreInfoTooltip_module = require('./styles/more-info-tooltip.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const MoreInfoTooltip = (props)=>{
    const { className , iconLabel ='More info' , iconSize =13 , width =widths.Widths.Medium , wrapperProps , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseTooltip.BaseTooltip, _extends({}, otherProps, {
        className: classnames__default.default(moreInfoTooltip_module.tooltip, moreInfoTooltip_module[colors.Colors.Primary], !!width && moreInfoTooltip_module[width], className),
        variantName: "more-info",
        wrapperProps: {
            ...wrapperProps,
            className: classnames__default.default(moreInfoTooltip_module.wrapper, wrapperProps && wrapperProps.className)
        }
    }), /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, {
        "aria-label": iconLabel,
        color: fontIcon$1.FontIconColors.Primary,
        icon: fontIcon$1.FontIcons.ToolTip,
        iconSize: iconSize,
        tabIndex: 0
    }));
};

exports.MoreInfoTooltip = MoreInfoTooltip;
//# sourceMappingURL=more-info-tooltip.js.map
